import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-modal-publication-picture',
    templateUrl: './modal-publication-picture.component.html',
    styleUrls: ['./modal-publication-picture.component.scss'],
})
export class ModalPublicationPictureComponent implements OnInit {
    displayModal: boolean;
    @Input() pictureAccessLink: string;

    constructor() {}

    ngOnInit(): void {}
    public showModalDialog() {
        this.displayModal = true;
    }
}
